import React from 'react'
import DocumentIcon from '../../../views/components/atoms/Icons/Doc/Document'
import PropertiesIcon from '../../../views/components/atoms/Icons/Property/Properties'
import ComplexIcon from '../../../views/components/atoms/Icons/Property/Complex'
import ContactIcon from '../../../views/components/atoms/Icons/User/Contact'
import ContactsIcon from '../../../views/components/atoms/Icons/User/Contacts'
import StatementIcon from '../../../views/components/atoms/Icons/Doc/Statement'
import TermIcon from '../../../views/components/atoms/Icons/Controls/Calendar'
import RentIcon from '../../../views/components/atoms/Icons/Property/Room'
import SettingsIcon from '../../../views/components/atoms/Icons/Controls/Settings'
import CommissionIcon from '../../../views/components/atoms/Icons/Finance/Withdraw'
import InvoicesIcon from '../../../views/components/atoms/Icons/Doc/Invoice'
import RenewalIcon from '../../../views/components/atoms/Icons/Controls/Refresh'
import TerminationIcon from '../../../views/components/atoms/Icons/Controls/Delete'
import ActivateIcon from '../../../views/components/atoms/Icons/Controls/CheckDouble'
import Label from '../../../views/components/atoms/Label/Label'
import { PortfolioWizardStepNames } from './types'

export const StaticStepIcons: Partial<Record<PortfolioWizardStepNames, React.FC>> = {
  [PortfolioWizardStepNames.type]: () => <DocumentIcon />,
  [PortfolioWizardStepNames.property]: () => <ComplexIcon />,
  [PortfolioWizardStepNames.lease]: () => <TermIcon />,
  [PortfolioWizardStepNames.rent]: () => <RentIcon />,
  [PortfolioWizardStepNames.settings]: () => <SettingsIcon />,
  [PortfolioWizardStepNames.commission]: () => <CommissionIcon />,
  [PortfolioWizardStepNames.invoices]: () => <InvoicesIcon />,
  [PortfolioWizardStepNames.activation]: () => <ActivateIcon />,
  [PortfolioWizardStepNames.renewal]: () => <RenewalIcon />,
  [PortfolioWizardStepNames.termination]: () => <TerminationIcon />,
}

const countBadgeContainerStyle: React.CSSProperties = {
  position: 'absolute',
  left: '15px',
  top: '15px',
  margin: '0',
}

const countBadgeLabelStyle: React.CSSProperties = {
  minWidth: '20px',
  backgroundColor: 'rgba(229,227,229)',
  lineHeight: '17px',
}

export const createCountBadgeIcon = (BaseIcon: React.FC, count: number): React.FC => {
  const CountBadgeIcon: React.FC = () => (
    <>
      <span>
        <BaseIcon />
        <span style={countBadgeContainerStyle}>
          <Label circular size="sm" style={countBadgeLabelStyle}>
            {count}
          </Label>
        </span>
      </span>
    </>
  )
  return CountBadgeIcon
}

export { ContactIcon, ContactsIcon, StatementIcon }
